import { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import SectionTitle from '../SectionTitle/SectionTitle';
import { getTestimonial } from '../../api/Testimonial';

const Testimonial = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [mainImage, setMainImage] = useState(null);
    const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

    useEffect(() => {
        getTestimonial().then((data) => {
            setTestimonials(data);
            if (data.length > 0) {
                setMainImage(data[0].banner); // default main image for first testimonial
            }
        });
    }, []);

    if (!testimonials.length) return null;

    const activeTestimonial = testimonials[activeIndex];
    const imagesArray = activeTestimonial.images ? JSON.parse(activeTestimonial.images) : [];

    return (
        <section 
            className="wpo-testimonial-section section-padding"
            style={{
                paddingTop: "40px",   // reduce vertical padding
                paddingBottom: "40px"
            }}
        >
            <div className="container">
                <div 
                    className="text-center mb-4"
                    style={{
                        height: "100px"
                    }}
                >
                    <SectionTitle
                        subTitle={"CLIENT TESTIMONIAL"}
                        Title={"Best Word Our Clients"}
                    />
                </div>
                <div className="wpo-testimonial-wrap">
                    <div className="row">
                        {/* Left side (Text slider) */}
                        <div className="col-lg-6">
                            <div className="wpo-testimonial-items">
                                <Slider
                                    dots={true}
                                    arrows={false}
                                    infinite={true}
                                    slidesToShow={1}        
                                    slidesToScroll={1}        
                                    adaptiveHeight={true}     
                                    speed={500}
                                    fade={true}
                                    beforeChange={(oldIndex, newIndex) => {
                                        setActiveIndex(newIndex);
                                        setMainImage(testimonials[newIndex].banner);
                                    }}
                                >
                                    {testimonials.map((tesmnl, tsm) => (
                                        <div className="wpo-testimonial-item" key={tsm}>
                                            <div>
                                                <h3>{tesmnl.name}</h3>
                                            </div>
                                            <div className="wpo-testimonial-text">
                                                <p
                                                    style={{ fontStyle: "italic", textAlign: "justify" }}
                                                >
                                                    <span dangerouslySetInnerHTML={{ __html: tesmnl.description }} />
                                                </p>
                                                <div className="wpo-testimonial-text-btm">
                                                    <span>{tesmnl.role}</span>
                                                    <h3>{tesmnl.title}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>

                        {/* Right side (Images with zoom + thumbnails) */}
                        {(mainImage || imagesArray.length > 0) && (
                        <div 
                            className="col-lg-5 offset-lg-1"
                            style={{
                                display: "flex",
                                alignItems: "end",
                            }}
                        >
                            <div className="testimonial-right-side" style={{ textAlign: "center" }}>
                                {/* Main Image (Zoom optional) */}
                                {mainImage && (
                                    <div style={{ marginBottom: "15px" }}>
                                        <Zoom>
                                            <img
                                                src={`${apiUrl}/storage/${mainImage}`}
                                                alt={activeTestimonial.title || "testimonial image"}
                                                style={{
                                                    width: "400px",              // Fill full width of parent container
                                                    maxWidth: "100%",        // Prevent overflow
                                                    height: "280px",            // Increase height for larger display
                                                    objectFit: "cover",         // Makes it cover fully, cropping if needed
                                                    objectPosition: "center",   // Center the focus of the image
                                                    borderRadius: "20px",
                                                    border: "1px solid lightgray",
                                                    marginBottom: "15px",
                                                    backgroundColor: "#f5f5f5", // Optional: fills space for small images
                                                }}
                                            />
                                        </Zoom>
                                    </div>
                                )}

                                {/* Thumbnails (only if available) */}
                                {(activeTestimonial.banner || imagesArray.length > 0) && (
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "10px",
                                            flexWrap: "wrap",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {/* Banner Thumbnail */}
                                        {activeTestimonial.banner && (
                                            <img
                                                src={`${apiUrl}/storage/${activeTestimonial.banner}`}
                                                alt="banner-thumb"
                                                onClick={() => setMainImage(activeTestimonial.banner)}
                                                style={{
                                                    width: "90px",
                                                    height: "90px",
                                                    objectFit: "cover",
                                                    borderRadius: "5px",
                                                    border:
                                                        mainImage === activeTestimonial.banner
                                                            ? "2px solid #000"
                                                            : "1px solid #ddd",
                                                    cursor: "pointer",
                                                }}
                                            />
                                        )}

                                        {/* Extra Images */}
                                        {imagesArray.map((img, index) => (
                                            <img
                                                key={index}
                                                src={`${apiUrl}/storage/${img}`}
                                                alt={`testimonial-${index}`}
                                                onClick={() => setMainImage(img)}
                                                style={{
                                                    width: "90px",
                                                    height: "90px",
                                                    objectFit: "cover",
                                                    borderRadius: "5px",
                                                    border:
                                                        mainImage === img
                                                            ? "2px solid #000"
                                                            : "1px solid #ddd",
                                                    cursor: "pointer",
                                                }}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;
